import { createContext, useContext } from "react";

/**
 * Which Vault model the studio is open on, for the panels that persist against
 * one (Embed, Branding, Batch Renderer).
 *
 * A context rather than prop-drilling because these are leaf panels resolved
 * through a registry — `LEFT_PANELS` maps an id to a bare `ComponentType`, so
 * there is nowhere to hand them a prop without giving every panel a signature
 * it does not want.
 *
 * `undefined` is a normal value, not a missing one: `/dev/studio` has no model,
 * and the panels say so rather than failing.
 */
export const StudioModelContext = createContext<string | undefined>(undefined);

export const useStudioModelId = () => useContext(StudioModelContext);
